import { useSnackbar, VariantType } from 'notistack'

type CopyOptions = {
  successMessage?: string
  variant?: VariantType
  suppressSnackbar?: boolean
}

export const useCopyToClipboard = () => {
  const { enqueueSnackbar } = useSnackbar()

  const copyToClipboard = async (
    value: Record<string, unknown> | string,
    options?: CopyOptions
  ) => {
    let contentToCopy = value

    if (typeof value !== 'string') {
      contentToCopy = JSON.stringify(value, null, 4)
    }

    try {
      await navigator.clipboard.writeText(contentToCopy as string)
      if (!options?.suppressSnackbar) {
        enqueueSnackbar(options?.successMessage || 'Copied!', {
          variant: options?.variant || 'success'
        })
      }
    } catch (e) {
      if (!options?.suppressSnackbar) {
        enqueueSnackbar('Cannot copy to clipboard. Try again later', {
          variant: 'error'
        })
      }
    }
  }

  return { copyToClipboard }
}
